'use strict';

jQuery(function($) {

	var $window = $(window),
		$body = $('body'),
		screenWidth = window.innerWidth ? window.innerWidth : $window.width(),
		screenHeight = window.innerHeight ? window.innerHeight : $window.height(),
		scrollBarWidth = 0;

	$window.on('resize orientationchange', function() {
		screenWidth = window.innerWidth ? window.innerWidth : $window.width();
		screenHeight = window.innerHeight ? window.innerHeight : $window.height();
	});

	$window.on('load', function() {
		$window.resize();
	});

	$(function () { objectFitImages() }); // Object Fit PolyFill for IE and Safari

	window.codecrew = {
		init : function() {
			this.resizedEvent(400); // Trigger Event after Window is Resized
			this.disableEmptyLinks(); // Disable Empty Links
			this.toolTips(); // ToolTips Init
			this.placeHolders(); // PlaceHolders Init
			this.scrollToAnchors(); // Smooth Scroll to Anchors
			this.scrollBarWidthDetection(); // ScrollBar Width Detection
			this.videoPlayerRatio(); // Video Player Ratio

			this.dropDownMenu(); // Dropdown Menu in Header
			this.recipeSliderInit(); // Recipe Slider
			this.owlSlidersInit(); // Owl Carousels
			this.imagesDelay(); // Images Delay
			this.heroSlider(); // Hero slider with products
			this.productForm(); // Product Quantity
			this.thumbnailSlider(); // Thumbnail Slider in Product Details
			this.shopCategories(); // Shop Categories Masonry
			this.shopProducts(); // Shop Products Layout/Filtering
			//this.cartPopup(); // Cart Popup
			this.brewFAQ(); // Brew Q&A

		},

		resizedEvent : function(delay) {
			var resizeTimerId;

			$window.on('resize orientationchange', function() {
				clearTimeout(resizeTimerId);

				resizeTimerId = setTimeout( function() {
					$window.trigger('resized');
				}, delay);
			});
		},

		disableEmptyLinks : function() {
			$('[href="#"], .btn.disabled').on('click', function(event) {
				event.preventDefault();
			});
		},

		toolTips : function() {
			$('[data-toggle="tooltip"]').tooltip();
		},

		placeHolders : function() {
			if ($('[placeholder]').length) {
				$.Placeholder.init();
			}
		},

		scrollToAnchors : function() {
			$('.anchor[href^="#"]').on('click', function(e) {
				e.preventDefault();
				var speed = 1,
					boost = 1,
					offset = 30,
					target = $(this).attr('href'),
					currPos = parseInt($window.scrollTop(), 10),
					targetPos = target!="#" && $(target).length==1 ? parseInt($(target).offset().top, 10) - offset : 0,
					distance = targetPos - currPos;

				boost = Math.abs(distance * boost / 1000);

				$("html, body").animate({scrollTop: targetPos}, parseInt(Math.abs(distance / (speed + boost)), 10));
			});
		},

		scrollBarWidthDetection : function() {
			$body.append('<div class="scrollbar-detect"><span></span></div>');

			var scrollBarDetect = $('.scrollbar-detect');

			scrollBarWidth = scrollBarDetect.width() - scrollBarDetect.find('span').width();

			scrollBarDetect.remove();
		},

		videoPlayerRatio : function() {
			function setRatio() {
				$('.video-player').each(function() {
					var self = $(this);
					var ratio = self.attr('width') && self.attr('height') ? self.attr('width') / self.attr('height') : 16/9;
					var	videoWidth = self.data('width-ref') ? $(self.data('width-ref')).width() : self.width();

					self.css({height: parseInt(videoWidth / ratio)});
					self.trigger('videoPlayerRatioSet');
				});
			}

			setRatio();

			$window.on('resized', function() {
				setRatio();
			});
		},

		dropDownMenu : function() {
			$('.main-menu').codecrewNavigation({
				animationIn: 'growInBigY',
				animationOut: 'growOutBigY',
				mobileBreakPoint: 991
			});
		},

		recipeSliderInit : function() {
			// Recipe Slider
			var slider = $('#recipeSlider');

			if (!slider.length) return;

			var images = slider.find('.slide-image');
			var nextImage = slider.find('.carousel-item.active').find('.slide-image');
			var nextImageSrc = nextImage.data('src');
			var counter = 0;

			$window.on('load', function() {
				$('.recipe-images-preloader').remove();

				slider.carousel({
					ride: 'carousel',
					interval: 6500,
					pause: false
				});

				nextImage.attr('src', nextImageSrc);

				slider.on('slide.bs.carousel', function (e) {
					counter++;

					images.attr('src', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12P4zwAAAgEBAKrChTYAAAAASUVORK5CYII=');

					nextImage = $(e.relatedTarget).find('.slide-image');

					nextImageSrc = nextImage.data('src');

					//setTimeout(function() {
						//nextImage.attr('src', nextImageSrc + '?v=' + counter);
						nextImage.attr('src', nextImageSrc);
					//}, 50);
				});
			});
		},


		owlSlidersInit : function() {
			// Testimonials Slider
			$('.testimonials-slider').owlCarousel({
				navigation: false,
				items: 1,
				slideSpeed: 300,
				paginationSpeed: 800,
				singleItem: true,
				dots: true
			});

			// Products Slider
			$('.products-slider').owlCarousel({
				slideSpeed: 300,
				paginationSpeed: 800,
				loop: true,
				nav: true,
				navText: ['prev','next'],
				dots: false,
				autoplay: true,
				autoplayTimeout: 500000,
				autoplayHoverPause: true,
				margin: 30,
				responsive:{
					0:{
						items: 1
					},
					768:{
						items: 2,
						margin: 10
					},
					992:{
						items: 3
					}
				}
			});

			// Post Slider
			/*$('.post-slider').owlCarousel({
				slideSpeed: 300,
				paginationSpeed: 800,
				loop: true,
				nav: true,
				navText: ['prev','next'],
				dots: false,
				autoplay: false,
				autoplayHoverPause: true,
				items: 1,
				singleItem: true
			});

			$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
				var tabId = $(e.target).attr('href');
				$(tabId).find('.post-slider').trigger('refresh.owl.carousel');
			});*/

			// Instagram Slider
			$('.instagram-slider').each(function() {
				var slider = $(this);

				function initInstagramSlider() {
					if (screenWidth < 992) {
						slider.owlCarousel({
							slideSpeed: 300,
							paginationSpeed: 800,
							loop: false,
							nav: true,
							navText: ['prev','next'],
							dots: false,
							autoplay: true,
							autoplayTimeout: 5000,
							autoplayHoverPause: true,
							margin: 10,
							responsive:{
								0:{
									items: 1
								},
								576:{
									items: 2
								},
								768:{
									items: 4
								},
								992:{
									items: 5
								}
							}
						});
					} else {
						slider.owlCarousel('destroy');
					}
				}

				initInstagramSlider();
				
				$window.on('resized', function() {
					initInstagramSlider();
				});
			});
		},

		imagesDelay : function() {
			var delayMargin = 300;
			var delayedImages = [];

			$('img').each(function() {
				var image = $(this);

				if(image.hasClass('delay-load')) {
					delayedImages.push(image);
				}
			});

			if (delayedImages.length) {
				$window.on('scroll', function() {
					delayMargin = ($window.scrollTop() + screenHeight < 2000) ? 300 : 1000;

					$.each(delayedImages, function(index, image) {
						if($window.scrollTop() + screenHeight >= $(this).offset().top - delayMargin) {
							image.attr('src', $(this).attr('data-src'));
						}
					});
				});
			}
		},

		heroSlider : function() {
			$('.js-hero-slide').each(function() {
				var slide = $(this);
				var products = slide.find('.hero-slide-product');
				var activeSlideName = '';
				var activeSlide = products.eq(0);
				var animationTime = 500;

				slide.find('.product-bullets').find('a').on('click', function() {
					activeSlideName = $(this).data('product');
					activeSlide = products.filter('[data-product="' + activeSlideName + '"]');

					if (screenWidth < 768) {
						slide.css({
							height: products.filter(':visible').outerHeight()
						});
					} else {
						slide.attr('style', '');
					}

					products.filter(':visible').addClass('changing').fadeOut(animationTime, function() {
						$(this).removeClass('changing');
					});

					products.filter('[data-product="' + activeSlideName + '"]').addClass('changing').fadeIn(animationTime, function() {
						$(this).removeClass('changing');
						slide.attr('style', '');
					});
				});
			});
		},

		productForm : function() {
			$('.js-product-amount').each(function() {
				var form = $(this);
				var input = form.find('input');
				var buttonMinus = form.find('.button-minus');
				var buttonPlus = form.find('.button-plus');
				var value = input.data('value');

				function setQuantity(val) {
					if (val < 10) input.val('0' + val);
						else input.val(val);
				}

				setQuantity(value);

				buttonMinus.on('click', function() {
					if (value <= 1 || typeof value !== 'number') {
						value = 1;
						setQuantity(value);
					} else {
						value --;
						setQuantity(value);
					}
				});

				buttonPlus.on('click', function() {
					if (value < 1 || typeof value !== 'number') {
						value = 1;
						setQuantity(value);
					} else {
						value ++;
						setQuantity(value);
					}
				});

				input.on('blur', function() {
					value = isNaN(parseInt(input.val())) ? 1 : parseInt(input.val());
					setQuantity(value);
				});
			});
		},

		thumbnailSlider : function() {
			$.fn.imageSliderApi = function () {
				var slider = $(this),
					imagesWrap = slider.find('.slider-images-wrap'),
					images = slider.find('.slider-images'),
					thumbsWrap = slider.find('.slider-thumbs-inner'),
					thumbs = slider.find('.slider-thumbs'),
					prev = slider.find('.prev'),
					next = slider.find('.next'),
					thumbsCount = 4;

				images.trigger('destroy');
				thumbs.trigger('destroy');

				images.find('li').removeClass().css({
					width: imagesWrap.width()
				});

				if (screenWidth < 576) {
					thumbs.find('li').removeClass().css({
						width: thumbsWrap.width() / 2,
						height: thumbsWrap.width() / 2
					});

					thumbsCount = 2;
				} else {
					thumbs.find('li').removeClass().css({
						width: thumbsWrap.width() / 4,
						height: thumbsWrap.width() / 4
					});

					thumbsCount = 4;
				}

				images.carouFredSel({
					prev : prev,
					next : next,
					circular: false,
					infinite: false,
					items: 1,
					auto: false,
					scroll: {
						fx: 'quadratic',
						onBefore: function() {
							var pos = $(this).triggerHandler('currentPosition');

							thumbs.find('li').removeClass('active');
							thumbs.find('li.item' + pos).addClass('active');

							if(pos < 1) {
								thumbs.trigger('slideTo', [pos, true]);
							} else {
								thumbs.trigger('slideTo', [pos - 1, true]);
							}
						}
					},
					onCreate: function() {
						images.find('li').each(function(i) {
							$(this).addClass('item' + i);
						});
					}
				}).trigger('slideTo', [0, true]);

				thumbs.carouFredSel({
					//direction: 'up',
					auto: false,
					infinite: false,
					circular: false,
					items: thumbsCount,
					scroll: {
						items : 1
					},
					onCreate: function() {
						thumbs.find('li').each(function(i) {
							$(this).addClass( 'item' + i ).on('click', function() {
								images.trigger('slideTo', [i, true]);
							});
						});
						thumbs.find('.item0').addClass('active');
					}
				});

				if (Modernizr.touchevents) {
					images.swipe({
						swipeLeft: function() {
							images.trigger('next');
						},
						swipeRight: function() {
							images.trigger('prev');
						},
						threshold: 50,
						excludedElements: ''
					});
				}
			};

			var imageSlider = $('.thumbnail-slider');

			if(imageSlider.length) {
				$window.on('load resized', function() {
					imageSlider.each(function() {
						$(this).imageSliderApi();
					});
				});
			}
		},

		shopCategories : function() {
			var categories = $('.js-shop-categories-items'),
				categoriesItems = categories.children('.shop-categories-item'),
				gridSize = 10000,
				gridSizeIndex = 0,
				gridSizeItem;

			if(!categories.length) return false;

			categoriesItems.each(function(index) {
				if($(this).outerWidth() < gridSize) {
					gridSize = $(this).outerWidth();
					gridSizeIndex = index;
				}
			});

			gridSizeItem = categoriesItems.eq(gridSizeIndex);
			gridSizeItem.addClass('grid-sizer');

			var ratio = .76551724137931;

			$window.on('resize', function() {
				gridSize = gridSizeItem.outerWidth();

				categoriesItems.each(function() {
					var self = $(this);

					self.css({height: gridSize * ratio});

					if(self.hasClass('height2')) {
						self.css({height: gridSize * ratio * 2});
					}

					if(self.hasClass('height3')) {
						self.css({height: gridSize * ratio * 3});
					}

					if(self.hasClass('height4')) {
						self.css({height: gridSize * ratio * 4});
					}

					if(self.hasClass('height5')) {
						self.css({height: gridSize * ratio * 5});
					}
				});

				categories.isotope('layout');
			});

			categories.isotope({
				layoutMode: 'packery',
				transitionDuration: '1s',
				getSortData: {
					category: '[data-category]'
				},
				packery: {
					columnWidth: '.grid-sizer'
				},
				percentPosition: true
			});

			categories.imagesLoaded().progress(function() {
				categories.isotope('layout');
			});
		},

		shopProducts : function() {
			var productList = $('.js-product-items'),
				products = productList.children('.product-item'),
				filters = $('.js-products-filter').find('li'),
				topFilters = $('.js-shop-categories-items').find('[data-category]'),
				gridSize = 10000,
				gridSizeIndex = 0;

			if(!productList.length) return false;

			products.each(function(index) {
				if($(this).outerWidth() < gridSize) {
					gridSize = $(this).outerWidth();
					gridSizeIndex = index;
				}
			});

			products.eq(gridSizeIndex).addClass('grid-sizer');

			productList.isotope({
				layoutMode: 'packery',
				transitionDuration: '1s',
				getSortData: {
					category: '[data-category]'
				},
				packery: {
					columnWidth: '.grid-sizer'
				},
				percentPosition: true
			});

			productList.imagesLoaded().progress(function() {
				productList.isotope('layout');
			});

			filters.on('click', function(e) {
				e.preventDefault();

				var self = $(this),
					option = self.data('category');

				filters.removeClass('active');
				self.addClass('active');

				productsFiltering(option);
			});

			topFilters.on('click', function(e) {
				e.preventDefault();

				var self = $(this),
					option = self.data('category');

				filters.removeClass('active').filter('[data-category="' + option + '"]').addClass('active');

				productsFiltering(option);

				$("html, body").animate({
					scrollTop: productList.offset().top
				}, 500);
			});

			function productsFiltering(option) {
				var search = option ? function() {
					var $item = $(this),
						name = $item.data('category') ? $item.data('category') : '';
					return name.match(new RegExp(option));
				} : '*';

				productList.isotope({filter : search});
			}
		},

		cartPopup : function() {
			var popup = $('.cart-popup');

			var popupOpen = function() {
				popup.addClass('active');

				$body.addClass('overflow-hidden').css({
					paddingRight: scrollBarWidth
				});
			};

			var popupClose = function() {
				popup.removeClass('active');

				setTimeout(function() {
					$body.removeClass('overflow-hidden').css({
						paddingRight: 0
					});
				}, 200);
			};

			$('.cart-popup-open').on('click', popupOpen);
			$('.cart-popup-close').on('click', popupClose);

			popup.on('click', function(e) {console.log($(e.target).closest('.cart-popup-inner'));
				if (!$(e.target).closest('.cart-popup-inner').length) popupClose();
			});

			$('.cart-item-close').on('click', function(e) {
				e.preventDefault();
				$(this).closest('.cart-item').fadeOut(200);
			});
		},

		brewFAQ : function() {
			var categoryLinks = $('.brew-categories-item .item-link');
			var allCategoriesLink = $('.brew-categories-link');
			var categoriesContainer = $('.brew-categories-container');
			var categories = $('.brew-category');
			var category = '';

			categoryLinks.on('click', function() {
				category = $(this).data('category');
				categories.hide().filter('#' + category).show();
				allCategoriesLink.addClass('active');

				$("html, body").animate({
					scrollTop: allCategoriesLink.offset().top - 30
				}, 500);
			});

			allCategoriesLink.on('click', function() {
				categories.show();
				allCategoriesLink.removeClass('active');

				$("html, body").animate({
					//scrollTop: categoriesContainer.offset().top
					scrollTop: allCategoriesLink.offset().top - 30
				}, 500);
			});
		}

	};

	codecrew.init();
});